import { useNavigate, useParams } from "react-router-dom";
import { Formik, Form, FieldArray, Field } from "formik";
import { LANGUAGES } from "../../../mock/languages";
import { useState } from "react";
import { lang } from "../../../types/lang";
import { KTIcon } from "../../../../_metronic/helpers";
import { MyTooltip } from "../../../components/common/tooltip/Tooltip";
import { createVoteQuestionItem } from "../../../services/voteQuestionSvc";
import { useNotification } from "../../../context/NotificationContext";

export const VoteQuestionCreatePage = () => {
  const { categoryId } = useParams<{ categoryId: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<lang>("uz");
  const { showNotification } = useNotification();

  const handleTabChange = (lang: lang) => {
    setActiveTab(lang);
  };

  return (
    <div>
      <div className={"card"}>
        <div className="card-header">
          <h1 className="card-title">So'rovnoma qo'shish</h1>
          <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
            {LANGUAGES.map((lang) => (
              <li className="nav-item" key={lang.key}>
                <button
                  className={`nav-link ${
                    activeTab === lang.key ? "active" : ""
                  }`}
                  onClick={() => handleTabChange(lang.key as lang)}
                >
                  {lang.name}
                </button>
              </li>
            ))}
          </ul>
        </div>
        <div className="card-body">
          <Formik
            initialValues={{
              questions: [
                {
                  category: categoryId,
                  question: {
                    uz: "",
                    ru: "",
                    en: "",
                  },
                  is_text_answer: false,
                  is_active: true,
                  answers: [
                    {
                      answer: {
                        uz: "",
                        ru: "",
                        en: "",
                      },
                      is_active: true,
                    },
                  ],
                },
              ],
            }}
            onSubmit={async (values) => {
              const formattedValues = values.questions.map((question) => ({
                category: Number(question.category),
                question_uz: question.question.uz,
                question_ru: question.question.ru,
                question_en: question.question.en,
                is_text_answer: question.is_text_answer,
                is_active: question.is_active,
                answers: question.answers.map((answer) => ({
                  answer_uz: answer.answer.uz,
                  answer_ru: answer.answer.ru,
                  answer_en: answer.answer.en,
                  is_active: answer.is_active,
                })),
              }));
              try {
                const res = await createVoteQuestionItem(formattedValues);
                if (res[0].success) {
                  showNotification(
                    "Muvaffaqiyatli",
                    "Savollar qo'shildi",
                    "success"
                  );
                  navigate(-1);
                }
              } catch (e) {
                showNotification("Xatolik", "Savollar qo'shilmadi", "error");
                throw e;
              }
            }}
          >
            {(formik) => (
              <Form>
                <FieldArray name="questions">
                  {(arrayHelpers) => (
                    <div>
                      {formik.values.questions.length > 0 &&
                        formik.values.questions.map((question, index) => (
                          <div
                            key={index}
                            className="bg-gray-100 rounded mb-10 p-2"
                          >
                            <div className="d-flex justify-content-between mb-2">
                              <h3>Savol: {index + 1}</h3>
                              <MyTooltip
                                title="Savolni o'chirish"
                                position="top"
                              >
                                <button
                                  type="button"
                                  className="btn btn-light-danger btn-icon"
                                  onClick={() => arrayHelpers.remove(index)}
                                >
                                  <KTIcon
                                    iconName="trash-square"
                                    className="fs-1"
                                  />
                                </button>
                              </MyTooltip>
                            </div>
                            <Field
                              name={`questions.${index}.question.${activeTab}`}
                              placeholder={`Savol matni ${activeTab}`}
                              className="form-control mb-2"
                            />
                            <FieldArray name={`questions.${index}.answers`}>
                              {(answerArrayHelpers) => (
                                <div>
                                  {question.answers.length > 0 &&
                                    question.answers.map(
                                      (answer, answerIndex) => (
                                        <div
                                          key={answerIndex}
                                          className="d-flex align-items-center gap-2"
                                        >
                                          <Field
                                            className="form-control mb-2"
                                            name={`questions.${index}.answers.${answerIndex}.answer.${activeTab}`}
                                            placeholder={`Javob ${activeTab}`}
                                          />
                                          <MyTooltip
                                            title="Variantni o'chirish"
                                            position="top"
                                          >
                                            <button
                                              type="button"
                                              className="btn btn-danger btn-icon"
                                              onClick={() =>
                                                answerArrayHelpers.remove(
                                                  answerIndex
                                                )
                                              }
                                            >
                                              <KTIcon
                                                iconName="trash-square"
                                                className="fs-1"
                                              />
                                            </button>
                                          </MyTooltip>
                                        </div>
                                      )
                                    )}
                                  <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    onClick={() =>
                                      answerArrayHelpers.push({
                                        answer: {
                                          uz: "",
                                          ru: "",
                                          en: "",
                                        },
                                        is_active: true,
                                      })
                                    }
                                  >
                                    Yangi variant qo'shish
                                  </button>
                                </div>
                              )}
                            </FieldArray>
                            <div className="row mb-6">
                              <label className="col-lg-4 col-form-label fw-bold fs-6">
                                Holatni aktivlashtirish
                              </label>
                              <div className="col-lg-8 fv-row">
                                <div style={{ width: "fit-content" }}>
                                  <MyTooltip
                                    title={"Holatni aktivlashtirish"}
                                    position="top"
                                  >
                                    <div className="form-check form-check-solid form-switch fv-row">
                                      <Field
                                        type="checkbox"
                                        name={`questions.${index}.is_active`}
                                        className="form-check-input w-45px h-30px"
                                      />
                                      <label className="form-check-label"></label>
                                    </div>
                                  </MyTooltip>
                                </div>
                              </div>
                            </div>
                            <div className="row mb-6">
                              <label className="col-lg-4 col-form-label fw-bold fs-6">
                                Matn javobini aktivlashtirish
                              </label>
                              <div className="col-lg-8 fv-row">
                                <div style={{ width: "fit-content" }}>
                                  <MyTooltip
                                    title={"Matn javobini aktivlashtirish"}
                                    position="top"
                                  >
                                    <div className="form-check form-check-solid form-switch fv-row">
                                      <Field
                                        type="checkbox"
                                        name={`questions.${index}.is_text_answer`}
                                        className="form-check-input w-45px h-30px"
                                      />
                                      <label className="form-check-label"></label>
                                    </div>
                                  </MyTooltip>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                      <button
                        type="button"
                        className="btn btn-primary btn-sm"
                        onClick={() =>
                          arrayHelpers.push({
                            category: categoryId,
                            question: {
                              uz: "",
                              ru: "",
                              en: "",
                            },
                            is_text_answer: false,
                            is_active: true,
                            answers: [],
                          })
                        }
                      >
                        Yangi savol qo'shish
                      </button>
                    </div>
                  )}
                </FieldArray>
                <div className="d-flex justify-content-end mt-3 gap-2">
                  <button
                    type="button"
                    onClick={() => navigate(-1)}
                    className="btn btn-secondary"
                  >
                    Bekor qilish
                  </button>
                  <button
                    disabled={formik.isSubmitting}
                    type="submit"
                    className="btn btn-primary"
                  >
                    {formik.isSubmitting ? "Saqlanmoqda..." : "Saqlash"}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
